import React from 'react';

import PaddedRowWrapper from 'containers/PaddedRowWrapper';
import { TextWrapper } from './styles';

function Footer() {
  return (
    <PaddedRowWrapper backgroundColor="footerBackground">
      <TextWrapper>Copyright @ 2020</TextWrapper>
    </PaddedRowWrapper>
  );
}

export default Footer;
